module.exports = __webpack_public_path__ + "static/Eliza3-71b56467770dae84a2999fff9060f3d0.webp";